/* eslint-disable no-unused-vars */
import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import { translate } from "@/trans";
import store from "@/store";
import mocksData from "./mocksData.json";

const state = {
  spendingAccounts: null,
  providerServices: null,
  memberHasSickPay: false,
  neospinDocuments: [],
  spouseData: null,
};

const getters = {
  providerServices: (state) => {
    return state.providerServices;
  },
  memberHasHSA: (state) => {
    var memberHasDemoHSA = store.getters["common/hasDemoHSA"];
    var isDemoMockPlan = store.getters["common/isDemoMockPlan"];
    console.log({ memberHasDemoHSA, isDemoMockPlan });
    if (isDemoMockPlan && memberHasDemoHSA) {
      return true;
    }
    if (isDemoMockPlan && !memberHasDemoHSA) {
      return false;
    }
    return state.spendingAccounts?.some(
      (o) =>
        o.AccountType === "HealthSpendingAccount" &&
        o.Current !== null &&
        o.Current !== undefined
    );
  },
  memberHasWellness: (state) => {
    return state.spendingAccounts?.some(
      (o) =>
        o.AccountType === "WellnessAccount" &&
        o.Current !== null &&
        o.Current !== undefined
    );
  },
  memberHasSickPay: (state) => {
    return state.memberHasSickPay;
  },
  memberHSABalance: (state) => {
    return (
      state.spendingAccounts?.filter(
        (o) => o.AccountType === "HealthSpendingAccount"
      ).length &&
      state.spendingAccounts.filter(
        (o) => o.AccountType === "HealthSpendingAccount"
      )[0]?.CurrentBalance
    );
  },
  spouseData: (state) => state.spouseData,
};

const actions2 = {
  // eslint-disable-next-line
  async getSettings({ state }) {
    function sortModel(collection) {
      if (collection === null || collection === undefined) {
        return [];
      }
      const items = collection.sort((a, b) => {
        return translate(a).localeCompare(translate(b));
      });
      return items;
    }
    const settings = SettingsService.settings;
    const url = settings.APIURL + "settings";
    let options = (await ApiService.get(url)).data;
    state.options = options;
    for (let k of Object.keys(state.options.Models)) {
      state.options.Models[k] = sortModel(state.options.Models[k]);
    }
  },
  // eslint-disable-next-line no-unused-vars
  loadCoverageGroups({ state }, planId) {
    const url = `${SettingsService.settings.APIURL}optouts/PlanConfiguration/${planId}/coverage-groups`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  async loadOptOutConfig({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/${options.planId}/planConfiguration`;
    return ApiService.getGuest(url);
  },
  async getWaiverText({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/${options.planId}/planConfiguration/${options.waiverType}`;
    return ApiService.get(url);
  },

  //Opt-Ins
  getOptInValidPeriod({ state }, options) {
    const params = [];
    if (options.certificate)
      params.push(`certificate=${encodeURIComponent(options.certificate)}`);
    if (options.memberGroupId)
      params.push(`memberGroupId=${options.memberGroupId}`);
    const qs = params.length ? `?${params.join("&")}` : "";
    const url = `${SettingsService.settings.APIURL}opt-ins/${options.planId}/valid-period${qs}`;
    return ApiService.getGuest(url);
  },
  getMemberAvailableCoverageGroupsForOptIns({ state }, options) {
    let url = `${SettingsService.settings.APIURL}opt-ins/member-available-coverages/${options.certificate}`;
    if (options.memberGroupId) {
      url += `?memberGroupId=${options.memberGroupId}`;
    }
    return ApiService.get(url);
  },
  getMemberOptInSubmissions({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}opt-ins/member/${options.planId}/opt-ins-submissions/${options.certificate}`;
    return ApiService.get(url);
  },
  cancelOptInRequest({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}opt-ins/submissions/${options.submissionId}/requests/${options.requestId}`;
    return ApiService.delete(url);
  },

  // eslint-disable-next-line no-unused-vars
  getOptOutValidPeriod({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/${options.planId}/valid-period/${options.certificate}`;
    return ApiService.getGuest(url);
  },
  getCalculatedOwedAmount({ state }, options) {
    const url = `${SettingsService.settings.APIURL}add-dependants/calculate-owed-amount`;
    return ApiService.post(url, options.payload);
  },
  getCalculatedOwedAmountSubmission({ state }, options) {
    const url = `${SettingsService.settings.APIURL}add-dependants/calculate-owed-amount-submission`;
    return ApiService.post(url, options.payload);
  },
  getDependantValidPeriod({ state }, options) {
    const params = [];
    if (options.certificate)
      params.push(`certificate=${encodeURIComponent(options.certificate)}`);
    if (options.memberGroupId)
      params.push(`memberGroupId=${options.memberGroupId}`);
    const qs = params.length ? `?${params.join("&")}` : "";
    const url = `${SettingsService.settings.APIURL}add-dependants/${options.planId}/valid-period${qs}`;
    return ApiService.getGuest(url);
  },
  // eslint-disable-next-line no-unused-vars
  createAddDependantRequest({ state }, options) {
    const url = `${SettingsService.settings.APIURL}add-dependants/${options.planId}`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateAddDependantRequest({ state }, options) {
    const url = `${SettingsService.settings.APIURL}add-dependants/${options.dependantId}/update-dependant`;
    return ApiService.put(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  getMemberOptOuts({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optout/optouts/${options.planId}/${options.certificate}`;
    return ApiService.get(url);
  },
  getMemberAddDependants({ state }, options) {
    const settings = SettingsService.settings;

    const limit = options.limit != null ? options.limit : 10;
    const offset = options.offset != null ? options.offset : 0;

    const url =
      `${settings.APIURL}optouts/member/${options.planId}/dependants/${options.certificate}` +
      `/submission/${options.periodId}` +
      `?Limit=${limit}&Offset=${offset}`;
    return ApiService.get(url);
  },
  getMemberAddDependantSubmissions({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}optouts/member/${options.planId}/dependant-submissions/${options.certificate}`;
    return ApiService.get(url);
  },
  getAddDependantsSettings({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}add-dependants/${options.planId}/settings`;
    return ApiService.get(url);
  },
  getSubmissionTotalAmount({ state }, options) {
    const settings = SettingsService.settings;

    const url =
      `${settings.APIURL}optouts/member/${options.planId}` +
      `/dependants/${options.certificate}` +
      `/submissions/${options.periodId}/totalowed`;

    return ApiService.get(url);
  },
  getMemberReimbursments({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optout/reimbursments/${options.planId}/${options.certificate}`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  async getCoverageGroups({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/planConfiguration/${options.planId}/coverage-groups`;
    return await ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  async getOptOutMemberByCertificate({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/member/${options.certificate}`;
    return await ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  checkOptOutClaims({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/check-claims/${options.coverage}?startDate=${options.startDate}&endDate=${options.endDate}`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  createPlanMemberForInternalMemberGroup({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/plan-member`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  getMemberAvailableCoverageGroups({ state }, options) {
    let url = `${SettingsService.settings.APIURL}optouts/member-available-coverages/${options.certificate}`;
    if (options.memberGroupId) {
      url += `?memberGroupId=${options.memberGroupId}`;
    }
    return ApiService.get(url);
  },
  getAllMemberAvailableCoverageGroups({ state }, options) {
    let url = `${SettingsService.settings.APIURL}optouts/member-available-coverages-for-member/${options.certificate}`;
    return ApiService.get(url);
  },
  getPreRegistrationMemberGroups({ state }, options) {
    const url = `${SettingsService.settings.APIURL}optouts/planConfiguration/pre-registration-memberGroups/${options.planId}`;
    return ApiService.getGuest(url);
  },
  // eslint-disable-next-line
  async getMemberData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}`;
    return await ApiService.get(url);
  },
  // eslint-disable-next-line
  verifyRecaptchaToken({ state }, options) {
    const settings = SettingsService.settings;
    const payload = {
      secret: settings.RecaptchaSecret,
      response: options.token,
    };
    const url = `https://www.google.com/recaptcha/api/siteverify`;
    return ApiService.post(url, payload);
  },
  // eslint-disable-next-line no-unused-vars
  getPreRegistrationMemberDependants({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.certificate}/get-dependants`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line no-unused-vars
  deletePreRegistrationDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.memberId}/delete-dependant/${options.dependantId}`;
    return ApiService.delete(url, options.payload);
  },
  deleteMemberDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/delete-dependant/${options.dependantId}`;
    return ApiService.delete(url);
  },
  // eslint-disable-next-line no-unused-vars
  updatePreRegistrationDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.memberId}/dependant/${options.dependantId}`;
    return ApiService.put(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  cretePreRegistrationDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.memberId}/create-dependant`;
    return ApiService.post(url, options.payload);
  },
  postPreRegistrationDependants({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/create-preregistration-dependants`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  updatePreRegisterUpdateInformation({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.memberId}/update-information`;
    return ApiService.put(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  updatePreRegistrationSignature({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}pre-registration/member/${options.memberId}/update-signature`;
    return ApiService.put(url, { SignatureBase64: options.signatureBase64 });
  },
  // eslint-disable-next-line no-unused-vars
  checkValidMember({ state, rootState, rootGetters }, options) {
    const settings = SettingsService.settings;
    let isDemoMockPlan = rootGetters["common/isDemoMockPlan"];
    let isLocalPlan = rootGetters["common/isLocalPlan"];
    if (isDemoMockPlan || isLocalPlan) {
      let mockMember = mocksData.checkValidMemberMock;
      mockMember.data.PersonID =
        "888" + Math.floor(Math.random() * 1000000).toString();
      mockMember.data.MemberAccountID = mockMember.data.PersonID;
      console.log("checkValidMemberPension - demo member", mockMember);
      return mockMember;
    }
    const url = `${settings.APIURL}validate-member`;
    return ApiService.postGuest(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/validate-member`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  async cancelOptOut({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}optouts/requests/${options.requestId}/opt-outs/${options.id}/cancel`;
    return await ApiService.put(url, options.payload);
  },
  async updateOptOut({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}optouts/requests/${options.requestId}/opt-outs/${options.id}/update`;
    return await ApiService.put(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  checkValidMemberSba({ state, rootState, rootGetters }, options) {
    const settings = SettingsService.settings;
    let isDemoMockPlan = rootGetters["common/isDemoMockPlan"];
    let isLocalPlan = rootGetters["common/isLocalPlan"];
    if (isDemoMockPlan || isLocalPlan) {
      let mockMember = mocksData.checkValidMemberSbaMock;
      mockMember.data.Certificate = Math.floor(Math.random() * 1000000000);
      console.log("checkValidMemberSBA - demo member", mockMember);
      return mockMember;
    }
    const url = `${settings.APIURL}plans/${options.planIdentityId}/validate-drawbridge-member`;
    return ApiService.postGuest(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  checkPreRegistrationMemberExists({ state, rootState, rootGetters }, options) {
    const settings = SettingsService.settings;
    let isDemoMockPlan = rootGetters["common/isDemoMockPlan"];
    let isLocalPlan = rootGetters["common/isLocalPlan"];
    if (isDemoMockPlan || isLocalPlan) {
      return Promise.resolve({ data: {} });
    }
    const url = `${settings.APIURL}plans/${options.planIdentityId}/validate-pre-registration-member`;
    return ApiService.postGuest(url, options.payload);
  },
  // eslint-disable-next-line no-unused-vars
  checkValidEmail({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}validate-email`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  updateMemberPassword({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-password`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  updateMemberUsername({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-username`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  getMemberBeneficiaries({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/beneficiaries`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  saveMemberBeneficiaries({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/beneficiaries`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  getMemberPensionAccounts({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      if (mocksData.getMemberInfo) return mocksData.getMemberInfo;
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/info`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getPensionStatements({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      if (mocksData.getPensionStatements) return mocksData.getPensionStatements;
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/pensionstmt`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getDownloadCentreData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/download-centre`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getFaqData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/faq`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getMemberSettings({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/settings`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getAccountPendingData({ state }, options) {
    console.log("getting pending data");
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/account-pending`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getPensionLastUpdateData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/pension-last-update`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getDocumentsNewData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/documents-new`;
    return ApiService.get(url);
  },
  async fetchNeospinDocuments({ state }, options) {
    const settings = SettingsService.settings;
    if (state.neospinDocuments.length > 0) {
      console.log("fetchNeospinDocuments - using cached data");
      return new Promise((resolve) => {
        resolve(state.neospinDocuments);
      });
    }
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.personId}/neospin-documents`;
    // const url = `https://uat.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.personId}/neospin-documents`;
    try {
      const res = await ApiService.get(url);
      // const res = await ApiService.getDeployedProxy(url);
      if (res.data) {
        state.neospinDocuments = res.data;
        return new Promise((resolve) => {
          resolve(state.neospinDocuments);
        });
      } else {
        return new Promise((resolve) => {
          resolve([]);
        });
      }
    } catch (error) {
      state.neospinDocuments = [];
      return new Promise((resolve) => {
        resolve(state.neospinDocuments);
      });
    }
  },

  async getNeospinDocuments({ state }, options) {
    // const settings = SettingsService.settings;
    // const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.personId}/neospin-documents`;
    // return ApiService.get(url);
    // const url = `https://uat.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.personId}/neospin-documents`;
    // return ApiService.getDeployedProxy(url);
    if (state.neospinDocuments.length === 0) {
      await this.fetchNeospinDocuments({ state }, options);
    }
    const dataToReturn = { data: state.neospinDocuments };
    return new Promise((resolve) => {
      resolve(dataToReturn);
    });
  },
  // eslint-disable-next-line
  getResourcesNewData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/resources-new`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getNewsData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/news`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getPensionSummaryData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/pension-summary`;
    return ApiService.get(url);
  },
  getAssetsData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/assets`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getDownloadsData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/downloads`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getBeneficiariesData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/beneficiaries`;
    return ApiService.get(url);
  },
  getClaimsData({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/claims`;
    return ApiService.get(url);
  },
  getBenefitCards({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/benefit-cards`;
    return ApiService.get(url);
  },
  getHoursBankBalance({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}eligibility-bank/${options.memberIdentityId}/current-balance`;
    return ApiService.get(url);
  },
  getHoursBankHistory({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}eligibility-bank/${options.memberIdentityId}/history`;
    return ApiService.get(url);
  },
  getSelfPayment({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}self-payments/${options.id}?$expand=SelfPaymentCondition,SelfPaymentSetting($expand=SelfPaymentConditions)
`;
    return ApiService.get(url);
  },
  getSickPay({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/sick-hour-bank`;
    return ApiService.get(url);
  },
  getBenefitBalancesLegacy({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/benefit-balances`;
    return ApiService.get(url);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/benefit-balances`;
    // return ApiService.getDeployedProxy(url);
  },
  getBenefitBalancesDrawbridge({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}benefit-balance/fetch`;
    return ApiService.post(url, options.payload);
    // const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/benefit-balance/fetch`;
    // return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/benefit-balance/fetch`;
    // return ApiService.getDeployedProxy(url, options.payload);
  },
  getMostFrequentBenefitBalancesDrawbridge({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}benefit-balance/most-frequent`;
    return ApiService.post(url, options.payload);
  },
  // getHSACredits({ state }, options) {
  //   const settings = SettingsService.settings;
  //   const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/spending-account-yearly-balances/{options.memberSpendingAccountId}`;
  //   return ApiService.get(url);
  // },
  getSpendingAccountBalances({ state }, options) {
    const settings = SettingsService.settings;
    //select=CurrentBalance&$expand=Plan,YearlyBalances,YearlyBalanceToExpire
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/spending-accounts?$select=CurrentBalance&$expand=Plan,YearlyBalances,YearlyBalanceToExpire`;
    return ApiService.get(url);
  },
  async getSpendingAccount({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/spending-accounts?$select=CurrentBalance,AccountType&$expand=Plan,YearlyBalances($expand=Transactions),YearlyBalanceToExpire,Current($expand=PlanSpendingAccount($expand=Translations))`;
    var isDemoMockPlan = store.getters["common/isDemoMockPlan"];
    if (isDemoMockPlan) {
      state.spendingAccounts = mocksData?.getHsaMock?.data?.value;
      console.log("getSpendingAccount - demo hsa", state.spendingAccounts);
      return state.spendingAccounts;
    } else {
      state.spendingAccounts = (await ApiService.get(url)).data?.value;
    }
    return state.spendingAccounts;
  },
  getPlanBenefits({ state }, options) {
    const settings = SettingsService.settings;
    let hasHSA = options.hasHSA === true || false;
    let hasWellness = options.hasWellness === true || false;
    let url = `${settings.APIURL}plans/${
      options.planIdentityId
    }/plan-benefit/members/${
      options.memberIdentityId
    }/hsa/${hasHSA.toString()}/wellness/${hasWellness.toString()}`;
    return ApiService.get(url);
  },
  getGroupBenefits({ state }, options) {
    const settings = SettingsService.settings;
    // let url = `${settings.APIURL}plans/${options.planIdentityId}/plan-benefit/${
    //   options.hasHSA ? "true" : "false"
    // }/${options.memberGroupId}`;
    let hasHSA = options.hasHSA === true || false;
    let hasWellness = options.hasWellness === true || false;
    let url = `${settings.APIURL}plans/${
      options.planIdentityId
    }/plan-benefit/member-group/${options.memberGroupId}/effective-date/${
      options.effectiveDate
    }/hsa/${hasHSA.toString()}/wellness/${hasWellness.toString()}`;
    console.log("get plan benefits options:", options, "url", url);
    return ApiService.get(url);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${
    //   options.planIdentityId
    // }/plan-benefit/${options.hasHSA ? "true" : "false"}/${
    //   options.memberGroupId
    // }`;
    // return ApiService.getDeployedProxy(url);
  },
  getSickDaySubmissionSettings({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-submission-settings/member-group/${options.memberGroupId}/effective-date/${options.effectiveDate}`;
    return ApiService.get(url);
  },
  getMemberDependants({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/member-patients`;
    return ApiService.get(url);
  },
  getClaimDates({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/validate-member-patient-benefit`;
    return ApiService.post(url, options.payload);
  },
  getNotifications({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/notifications`;
    return ApiService.get(url);
  },
  searchDrugs({ state }, options) {
    const settings = SettingsService.settings;
    const nameQuery = options.name
      ? `contains(tolower(Name), '${options.name}')`
      : "";
    const dinQuery = options.din
      ? `contains(tolower(cast(Din, Edm.String)), '${options.din}')`
      : "";
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/drugs/${options.memberGroupId}`;
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/drugs/${options.memberGroupId}`;
    let pagination = "";
    if (options.itemsPerPage > 0) {
      pagination = `?$count=true&$skip=${
        options.itemsPerPage * (options.page - 1)
      }&$top=${options.itemsPerPage}`;
    } else {
      pagination = `?$count=true`;
    }

    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";
    const query =
      "&$filter=" + nameQuery + (nameQuery && dinQuery ? "&" : "") + dinQuery;
    return ApiService.get(url + pagination + sort + query);
    // return ApiService.getDeployedProxy(url + pagination + sort + query);
  },

  getPaidClaims({ state }, options) {
    const settings = SettingsService.settings;
    let filters = [];
    if (options.claimChequeNo) {
      // contains(cast(ClaimNumber, Edm.String ), '32842')
      filters.push(
        `contains(cast(ClaimNumber, Edm.String), '${options.claimChequeNo}') or contains(cast(ChequeNumber, Edm.String), '${options.claimChequeNo}')`
      );
    }

    if (options.patients) {
      filters.push(
        `ClaimHistoryDetails/any(__c_h: contains(tolower(__c_h/PatientName), '${options.patients.toLowerCase()}'))`
      );
    }

    if (options.statusDates && options.statusDates.length === 2) {
      filters.push(
        `StatusDate ge ${
          options.statusDates[0] + "T00:00:00.0000000Z"
        } and StatusDate le ${options.statusDates[1] + "T23:59:59.999999Z"}`
      );
    }

    if (options.statusDates && options.statusDates.length === 1) {
      let date = new Date(options.statusDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `StatusDate ge ${
          options.statusDates[0] + "T00:00:00.0000000Z"
        } and StatusDate lt ${date.toISOString()}`
      );
    }

    if (options.paidTo) {
      if (options.paidTo === "M") {
        filters.push(`PaidTo eq 'M'`);
      } else {
        filters.push(`PaidTo ne 'M'`);
      }
    }

    if (options.dateOfServiceDates.length === 2) {
      filters.push(
        `ClaimHistoryDetails/any(__c_h: __c_h/DateOfService ge ${
          options.dateOfServiceDates[0] + "T00:00:00.0000000Z"
        } and __c_h/DateOfService le ${
          options.dateOfServiceDates[1] + "T23:59:59.999999Z"
        })`
      );
    }

    if (options.dateOfServiceDates.length === 1) {
      let date = new Date(options.dateOfServiceDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `ClaimHistoryDetails/any(__c_h: __c_h/DateOfService ge ${
          options.dateOfServiceDates[0] + "T00:00:00.0000000Z"
        } and __c_h/DateOfService lt ${date.toISOString()})`
      );
    }

    if (!options.selectAmountRange && options.claimedAmount) {
      filters.push(`TotalSubmitted eq ${options.claimedAmount}`);
    }

    if (options.selectAmountRange && options.claimedAmountRange) {
      filters.push(
        `TotalSubmitted ge ${options.claimedAmountRange[0]} and TotalSubmitted le ${options.claimedAmountRange[1]}`
      );
    }

    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/claims`;
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/claims-summary`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/claims-summary`;
    const expandQuery = "?$expand=ClaimHistoryDetails";
    const pagination = `&$count=true&$skip=${
      options.itemsPerPage * (options.page - 1)
    }&$top=${options.itemsPerPage}`;
    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";

    let filter = `&$filter=(StudentNumber eq '${options.studentNumber}')`;
    let additionalFilters =
      filters.length !== 0
        ? " and " +
          filters
            .map((o) => {
              return `(${o})`;
            })
            .join(" and ")
        : "";

    // console.log(
    //   "searching paid claims Filter",
    //   expandQuery + pagination + sort + filter + additionalFilters
    // );
    return ApiService.get(
      url + expandQuery + pagination + sort + filter + additionalFilters
    );
    // return ApiService.getDeployedProxy(
    //   url + expandQuery + pagination + sort + filter + additionalFilters
    // );
  },
  searchClaims({ state }, options) {
    // console.log("search options", options);
    const settings = SettingsService.settings;
    let filters = [];
    if (options.submissionId) {
      filters.push(
        `contains(tolower(Identifier), '${options.submissionId.toLowerCase()}')`
      );
    }

    // Timestamp ge 2022-04-16T00:00:00.0000000Z and Timestamp le 2022-10-16T23:59:59.999999Z
    if (options.submissionDates && options.submissionDates.length === 2) {
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp le ${options.submissionDates[1] + "T23:59:59.999999Z"}`
      );
    }

    if (options.submissionDates && options.submissionDates.length === 1) {
      let date = new Date(options.submissionDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp lt ${date.toISOString()}`
      );
    }

    if (options.expenseDates.length === 2) {
      filters.push(
        `Claims/any(__c_t: __c_t/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/DateOfService le ${
          options.expenseDates[1] + "T23:59:59.999999Z"
        })`
      );
    }

    if (options.expenseDates.length === 1) {
      let date = new Date(options.expenseDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Claims/any(__c_t: __c_t/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/DateOfService lt ${date.toISOString()})`
      );
    }

    if (options.patientIds?.length) {
      console.log("patientIds", options.patientIds);
      let idsString = "";
      options.patientIds.forEach((id, i) => {
        if (id) {
          idsString += id + ", ";
        } else {
          idsString += "null, ";
        }
      });
      idsString = idsString.slice(0, -2);
      filters.push(`Claims/any(__c_t: __c_t/DependantId in (${idsString}))`);
    }

    if (options.coverages.length) {
      filters.push(
        `Claims/any(__c_t: __c_t/BenefitId in (${options.coverages.join(
          ", "
        )}))`
      );
    }

    if (options.status) {
      filters.push(`Status eq ${options.status}`);
    }

    if (!options.selectAmountRange && options.claimedAmount) {
      filters.push(`ClaimsTotal eq ${options.claimedAmount}`);
    }

    if (options.selectAmountRange && options.claimedAmountRange) {
      filters.push(
        `ClaimsTotal ge ${options.claimedAmountRange[0]} and ClaimsTotal le ${options.claimedAmountRange[1]}`
      );
    }

    const filter = filters.length ? "&$filter=" + filters.join(" and ") : "";

    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission/${options.memberIdentityId}`;
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/claim-submission/${options.memberIdentityId}`;

    const expandQuery =
      "?$expand=Proofs($expand=FileSegments)&$expand=Claims($expand=Benefit)";
    const pagination = `&$count=true&$skip=${
      options.itemsPerPage * (options.page - 1)
    }&$top=${options.itemsPerPage}`;
    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";

    // console.log(
    //   "searching submitted claims Filter",
    //   expandQuery + pagination + sort + filter
    // );
    return ApiService.get(url + expandQuery + pagination + sort + filter);
    // return ApiService.getDeployedProxy(
    //   url + expandQuery + pagination + sort + filter
    // );
  },
  searchDrawbridgeClaims({ state }, options) {
    console.log("search options", options);
    const settings = SettingsService.settings;
    let filters = [];

    // request was made to filter out claims which are not predetermination claims - IsPredetermined : true
    filters.push(`IsPredetermined ne true`);

    if (options.submissionId) {
      filters.push(
        `contains(tolower(Identifier), '${options.submissionId
          .toLowerCase()
          .replaceAll("'", "''")}')`
      );
    }

    // Timestamp ge 2022-04-16T00:00:00.0000000Z and Timestamp le 2022-10-16T23:59:59.999999Z
    if (options.submissionDates && options.submissionDates.length === 2) {
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp le ${options.submissionDates[1] + "T23:59:59.999999Z"}`
      );
    }

    if (options.submissionDates && options.submissionDates.length === 1) {
      let date = new Date(options.submissionDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp lt ${date.toISOString()}`
      );
    }

    if (options.expenseDates?.length === 2) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/CurrentClaimData/DateOfService le ${
          options.expenseDates[1] + "T23:59:59.999999Z"
        })`
      );
    }

    if (options.expenseDates?.length === 1) {
      let date = new Date(options.expenseDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/CurrentClaimData/DateOfService lt ${date.toISOString()})`
      );
    }

    if (options.patient) {
      // console.log("patient", options.patient);
      // filters.push(`Claims/any(__c_t: __c_t/Dependant/FirstName in (${idsString}))`);
      const parts = options.patient.split(" ");
      for (let i = 0; i < parts.length; i++) {
        filters.push(
          `Claims/any(__c1_t: contains(tolower(__c1_t/FirstName), '${parts[i]
            .toLowerCase()
            .replaceAll(
              "'",
              "''"
            )}') or Claims/any(__c2_t: contains(tolower(__c2_t/LastName), '${parts[
            i
          ]
            .toLowerCase()
            .replaceAll("'", "''")}')))`
        );
      }
    }

    // Only get ClaimSubmissions that have no empty Claims and have no Claims with status 'new' or 'deleted'
    filters.push("Claims/any()");
    filters.push(
      "Claims/any(__c_t: not contains(tolower(__c_t/State), 'new'))"
    );
    filters.push(
      "Claims/any(__c_t: not contains(tolower(__c_t/State), 'deleted'))"
    );
    if (options.status) {
      console.log("status", options.status);
      // filters.push(`Claims/any(__c_t: __c_t/Dependant/FirstName in (${idsString}))`);

      filters.push(
        `Claims/any(__c_t: contains(tolower(__c_t/State), '${options.status
          .toLowerCase()
          .replaceAll("'", "''")}'))`
      );
    }

    if (options.coverages?.length) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/PlanBenefitId in (${options.coverages.join(
          ", "
        )}))`
      );
    }

    if (!options.selectAmountRange && options.claimedAmount) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/ClaimedAmount eq ${options.claimedAmount})`
      );
    }

    if (options.selectAmountRange && options.claimedAmountRange) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/ClaimedAmount ge ${options.claimedAmountRange[0]} and __c_t/CurrentClaimData/ClaimedAmount le ${options.claimedAmountRange[1]})`
      );
    }

    const filter = filters.length ? "&$filter=" + filters.join(" and ") : "";

    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission-drawbridge`;
    //const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/claim-submission-drawbridge`;

    const expandQuery =
      "?$expand=Claims($expand=Proofs($expand=FileSegments),CurrentClaimData($expand=PlanBenefit($expand=Benefit($select=Name;$expand=Translations))))";
    const pagination = `&$count=true&$skip=${
      options.itemsPerPage * (options.page - 1)
    }&$top=${options.itemsPerPage}`;
    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";

    // console.log(
    //   "searching submitted claims Filter",
    //   expandQuery + pagination + sort + filter
    // );
    return ApiService.get(url + expandQuery + pagination + sort + filter);
    // return ApiService.getDeployedProxy(
    //   url + expandQuery + pagination + sort + filter
    // );
  },

  async getProviderServices({ state }, options) {
    if (!state.providerServices) {
      const settings = SettingsService.settings;
      // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/providerservices?$Expand=Translations`;
      // const res = await ApiService.getDeployedProxy(url);
      const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/providerservices?$Expand=Translations`;
      const res = await ApiService.get(url);
      state.providerServices = res.data.value;
    }
    return new Promise((resolve) => resolve(state.providerServices));
    // return ApiService.get(url);
    //return ApiService.getDeployedProxy(url);
  },
  searchProvider({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/search-provider?location=${options.payload.location}&service=${options.payload.service}`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  updateNotifications({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/notifications`;
    return ApiService.post(url, options.payload);
  },
  sendMessage({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/send-message`;
    return ApiService.post(url, options.payload);
  },
  sendHtml({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/send-html`;
    return ApiService.post(url, options.payload);
  },
  sendBenefitCardByEmail({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/benefit-cards/send`;
    return ApiService.post(url, options.payload);
  },
  submitClaim({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission`;
    return ApiService.post(url, options.payload);
  },
  canadaPostFind({ state }, options) {
    const settings = SettingsService.settings;
    // const url = `${settings.CanadaPostURL}Find/v2.10/json3.ws`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/canada-post/find`;
    let query = `?SearchTerm=${options.payload.SearchTerm}&Country=${options.payload.Country}&LanguagePreference=${options.payload.LanguagePreference}`;
    if (options.payload.LastId) {
      query += "&LastId=" + options.payload.LastId;
    }
    return ApiService.getGuest(url + query);
  },
  canadaPostRetrieve({ state }, options) {
    const settings = SettingsService.settings;
    // const url = `${settings.CanadaPostURL}Retrieve/v2.11/json3.ws`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/canada-post/retrieve`;
    const query = `?Id=${options.payload.Id}&LanguagePreference=${options.payload.LanguagePreference}`;
    return ApiService.getGuest(url + query);
  },
  // canadaPostFind({ state }, options) {
  //   const settings = SettingsService.settings;
  //   const url = `${settings.CanadaPostURL}Find/v2.10/json3.ws`;
  //   let query = `?Key=${options.payload.Key}&SearchTerm=${options.payload.SearchTerm}&Country=${options.payload.Country}&LanguagePreference=${options.payload.LanguagePreference}`;
  //   if (options.payload.LastId) {
  //     query += "&LastId=" + options.payload.LastId;
  //   }
  //   return ApiService.getCanadaPost(url + query);
  // },
  // canadaPostRetrieve({ state }, options) {
  //   const settings = SettingsService.settings;
  //   const url = `${settings.CanadaPostURL}Retrieve/v2.11/json3.ws`;
  //   const query = `?Key=${options.payload.Key}&Id=${options.payload.Id}&LanguagePreference=${options.payload.LanguagePreference}`;
  //   return ApiService.getCanadaPost(url + query);
  // },
  // async validateBankAccount({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const authUrl = settings.PaymentsApiAuthUri; //"https://api.payments.ca/accesstoken";
  //   // const authPayload = {
  //   //   Username: "V13jM95IfIqk0F8NxUlQSFnLi0DFoVKF",//"KtotzkxAovlnzw017OQ3YogVr7aNb6ut",
  //   //   Password: "WXHKD3GAZSNst0PH",//"B9D1YeCBCKpDbWWA",
  //   // };
  //   const authPayload = {
  //     Username: settings.PaymentsApiUser,
  //     Password: settings.PaymentsApiPass,
  //   };
  //   const token = (
  //     await ApiService.postPaymentsForm(authUrl, authPayload, {
  //       grant_type: "client_credentials",
  //     })
  //   ).data.access_token;
  //   const url = `${settings.PaymentsApiUri}${options.payload.InstitutionNumber}${options.payload.TransitNumber}`;
  //   return ApiService.getPayments(url, token);
  // },
  validateBankAccount({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "bank-accounts/validate";
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/bank-accounts/validate`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  slackNotify({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "slack-notify";
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/bank-accounts/validate`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  googleMapsSearch({ state }, options) {
    const settings = SettingsService.settings;
    let query = "";
    if (options.nexPageToken) {
      query = `?pagetoken=${options.nexPageToken}&key=${settings.GoogleAPIKEY}`;
    } else {
      query = `?query=${options.keyword}&location=${options.lat},${options.lng}&radius=${options.radius}&key=${settings.GoogleAPIKEY}`;
    }
    const url = `https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/textsearch/json`;
    //const url = `https://maps.googleapis.com/maps/api/place/textsearch/json`;
    return ApiService.getNoAuth(url + query);
  },
  // eslint-disable-next-line
  verifyMember({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/verify`;
    return ApiService.put(url, options.payload);
    //   const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/verify`;
    //   return ApiService.putDeployedProxy(url, options.payload);
  },
  // eslint-disable-next-line
  saveMember({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  saveMemberAddress({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-address`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-address`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  saveMemberContactInfo({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-contacts`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-contacts`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  saveMemberCommunicationInfo({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-communication`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-communication`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  // eslint-disable-next-line
  saveMemberDemographics({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: options.payload };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/save-demographics`;
    return ApiService.post(url, options.payload);
  },
  updateMemberInfoOnAllPlans({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-member-all-plans`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-member-all-plans`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  updateMemberBankInfo({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-bank-account`;
    return ApiService.put(url, options.payload);
  },
  // eslint-disable-next-line
  updateContactInfo({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-contact-info`;
    return ApiService.put(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-contact-info`;
    // return ApiService.putDeployedProxy(url, options.payload);
  },
  // eslint-disable-next-line
  updateBankAccount({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-bank-account`;
    return ApiService.put(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-bank-account`;
    // return ApiService.putDeployedProxy(url, options.payload);
  },
  // eslint-disable-next-line
  getDocumentFile({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/upload-files/get-files`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/upload-files/get-files`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  getNeospinFile({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}get-neospin-file/${options.documentId}`;
    return ApiService.get(url);
    // const url = `https://uat.mapi.pbasconnect.com/get-neospin-file/${options.documentId}`;
    // return ApiService.getDeployedProxy(url);
  },
  getFile({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/upload-files/${options.physicalFileId}`;
    return ApiService.get(url);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/upload-files/${options.physicalFileId}`;
    // return ApiService.getDeployedProxy(url);
  },
  getMultipleFilesZip({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/upload-files/get-files`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/upload-files/get-files`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  getMultipleFilesZipNeospin({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}get-neospin-files-zip`;
    return ApiService.post(url, options.payload);
    // const url = `https://uat.mapi.pbasconnect.com/get-neospin-files-zip`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  getFilesIds({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/upload-files/get-filesIds`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/upload-files/get-filesIds`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  getMemberFields({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/member-fields`;
    return ApiService.get(url, options.payload);
    // const url = `https://uat.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/member-fields`;
    // return ApiService.getDeployedProxy(url);
  },
  shareFileByEmail({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/share-files`;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/share-files`;
    // return ApiService.postDeployedProxy(url, options.payload);
  },
  changeEmail({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/change-email`;
    options.payload.ReturnUrl = window.location.origin;
    return ApiService.post(url, options.payload);
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/members/${options.memberIdentityId}/change-email`;
    // return ApiService.postDeployedProxy(url, options.payload);
    //const url = `http://localhost:5024/api/authenticate/ChangeEmail`;
    //return ApiService.post(url, options.payload);
  },
  getPlanCoveredBenefits({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/effective-date/${dateFormatted}/covered-benefits?$expand=Benefit`;
    return ApiService.get(url);
  },
  getSpendingAccountCoveredBenefits({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/covered-benefits/${options.coveredBenefitId}?$expand=Benefit&$filter=MemberOnly eq true`;
    return ApiService.get(url);
  },

  getMemberGroupIdentityId({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}members/${options.memberIdentityId}/date/${dateFormatted}/member-group-identity-id`;
    return ApiService.get(url);
  },

  setMockHSA({ state }, value) {
    console.log("setting mock HSA");
    state.spendingAccounts = value;
  },

  addDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/add-dependant`;
    return ApiService.post(url, options.payload);
  },
  updateDependant({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-dependant`;
    return ApiService.put(url, options.payload);
  },
  updateBeneficiaries({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/update-beneficiaries`;
    return ApiService.put(url, options.payload);
  },
  saveCcwippEnrollmentForm({ state }, options) {
    if (store.getters["common/isEnrollmentDemo"]) {
      localStorage.setItem(
        `enrollment_${options.userId}`,
        JSON.stringify(options.payload)
      );
      return { data: options.payload };
    }
    const settings = SettingsService.settings;
    const isBeneficiary = options.isBeneficiary || false;
    const url = `${settings.APIURL}enrollmentform/${options.userId}?isBeneficiary=${isBeneficiary}`;
    return ApiService.put(url, options.payload);
  },
  submitCcwippEnrollmentForm({ state }, options) {
    if (store.getters["common/isEnrollmentDemo"]) {
      const payload = {
        ...options.payload,
        SubmittedAt: new Date().toISOString(),
      };
      localStorage.setItem(
        `enrollment_${options.userId}`,
        JSON.stringify(payload)
      );
      return { data: payload };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}enrollmentform/${options.userId}/submit`;
    return ApiService.post(url, options.payload);
  },
  getCcwippEnrollmentForm({ state }, options) {
    if (store.getters["common/isEnrollmentDemo"]) {
      const key = `enrollment_${options.userId}`;
      let local = JSON.parse(localStorage.getItem(key));
      if (!local) {
        local = { Status: "Incomplete", EnrollmentForm: {} };
        localStorage.setItem(key, JSON.stringify(local));
      }
      return { data: local };
    }
    console.log(`Fetching ${options.userId}`);
    var settings = SettingsService.settings;
    const url = `${settings.APIURL}enrollmentform/${options.userId}`;
    return ApiService.get(url);
  },
  setSpouseData({ state }, data) {
    state.spouseData = data;
  },
  // eslint-disable-next-line
  async getSpouseData({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      if (mocksData.getSpouseData) {
        state.spouseData = mocksData.getSpouseData?.data || null;
        return mocksData.getSpouseData;
      }
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/spouse`;
    const result = await ApiService.get(url);
    state.spouseData = result?.data || null;
    return result;
  },
  // eslint-disable-next-line
  saveSpouseData({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: options.payload };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/spouse`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  getCcwippBeneficiaries({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      if (mocksData.getCcwippBeneficiaries)
        return mocksData.getCcwippBeneficiaries;
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/ccwipp-beneficiaries`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  saveCcwippBeneficiaries({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: options.payload };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/ccwipp-beneficiaries`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  cancelCcwippBeneficiary({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: "ok" };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/cancel-ccwipp-beneficiary/${options.beneficiaryId}`;
    return ApiService.post(url);
  },
  // eslint-disable-next-line
  getCcwippBeneficiaryDraft({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: null };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/ccwipp-beneficiary-draft`;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  saveCcwippBeneficiaryDraft({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: options.payload };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/ccwipp-beneficiary-draft`;
    return ApiService.post(url, options.payload);
  },
  // eslint-disable-next-line
  discardCcwippBeneficiaryDraft({ state }, options) {
    if (
      store.getters["common/isDemoMockPlan"] ||
      store.getters["common/addMeUseMockData"]
    ) {
      return { data: "ok" };
    }
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/discard-ccwipp-beneficiary-draft`;
    return ApiService.post(url);
  },
  getImageProxy({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}image-proxy?url=${encodeURIComponent(
      options.url
    )}`;
    return ApiService.get(url);
  },
};

const mutations = {};

const mocks = mocksData;

// For Demo portals return mock data
const actions = {};
Object.keys(actions2).forEach((k) => {
  actions[k] = (s, options) => {
    // console.log(s, options);
    if (store.getters["common/isDemoMockPlan"]) {
      //console.log("data.store: This is the Demo Mock Plan");
      if (mocks[k]) return mocks[k];
    }
    // console.log(actions2[k]);
    return actions2[k](s, options);
  };
});

export const data = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
